export default {
  // 省市区查询
  cityAddress: { url: '/v1/query/tools/address' },
};
